import styled from '@emotion/styled';
import { Div } from '../../layouts';

export const PaxSelectorDesktopEl = styled(Div)`
    .odf-rtl && {
      left: 0;
      right: auto;
    }
    && {
        right: 0;
    }
`;
